<template>
    <div>
        <h1 class="h3 mb-3 text-gray-800">{{ $t("Cadastro de Família") }}</h1>
        <div
            class="alert alert-info alert-dismissible fade show shadow text-dark"
            role="alert"
        >
            <h4>
                Olá, <b>{{ $store.state.user.full_name }}</b
                >!
            </h4>
            <h5 class="text-dark">
                Este é um cadastro básico para novas famílias. Após sua finalização, será possível inserir novos membros na composição familiar, assim como outras informações.
            </h5>
            <h5 class="mt-3">
                <b> Obs.</b> Apenas campos com <b class="text-danger">*</b> são
                de preenchimento obrigatório.
            </h5>
            <button
                type="button"
                class="close text-danger"
                data-dismiss="alert"
                aria-label="Close"
            >
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <b-card class="shadow">
            <template v-slot:default>
                <form @submit.prevent="addItem" ref="addItem">
                    <!--Bloco Responsável Familiar-->
                    <div class="row">
                        <h5 class="col-md-12 font-weight-bold">
                            Responsável Familiar
                        </h5>

                        <form-input
                            v-model="item.pessoa.nome_completo"
                            grid="9"
                            label="Nome Completo"
                            :required="true"
                            ajuda="Não será permitido acentos ou caracteres especiais neste campo."
                        />
                        <!-- <form-input
                            v-model="item.pessoa.nome_social"
                            grid="6"
                            label="Nome Social"
                        /> -->
                        <form-input
                            v-model="item.pessoa.data_nascimento"
                            grid="3"
                            v-mask="'##/##/####'"
                            label="Data de Nascimento"
                            :required="!item.endereco.situacao_rua"
                        />

                        <form-toggle
                            v-model="showfiltroNomeSocial"
                            grid="12"
                            label="Deseja adicionar Nome Social?"
                        />
                        <template v-if="showfiltroNomeSocial">
                            <form-input
                                grid="6"
                                v-model="item.pessoa.nome_social"
                                label="Nome Social"
                            />

                            <form-select
                                grid="6"
                                v-model="item.pessoa.origem_nome_social"
                                :itens="$root.arrays.origem_nome_social"
                                label="Origem do Nome Social"
                            />
                        </template>
                        <form-select
                            v-model="item.pessoa.sexo"
                            grid="4"
                            label="Sexo"
                            :itens="$root.arrays.sexo"
                        />
                        <form-select
                            v-model="item.pessoa.genero"
                            grid="4"
                            label="Gênero"
                            :itens="$root.arrays.genero"
                        />

                        <form-select
                            v-model="item.pessoa.cor_raca"
                            grid="4"
                            label="Cor/Raça"
                            :itens="$root.arrays.cor_raca"
                        />

                        <form-input
                            v-model="item.pessoa.mae"
                            grid="6"
                            label="Filiação 1"
                        />

                        <form-input
                            v-model="item.pessoa.pai"
                            grid="6"
                            label="Filiação 2"
                        />

                        <!--
                        <form-input
                            v-model="item.pessoa.telefone"
                            grid="4"
                            v-mask="'(##) # ####-####'"
                            placeholder="(00) 0 0000-0000"
                            label="Telefone"
                        />
                        <form-input
                            v-model="item.pessoa.celular"
                            grid="4"
                            v-mask="'(##) # ####-####'"
                            placeholder="(00) 0 0000-0000"
                            label="Celular/Whatsapp"
                        />
                        <form-input
                            v-model="item.pessoa.email"
                            grid="4"
                            label="E-mail"
                        /> -->

                        <div class="col-md-6 col-sm-12">
                            <div class="row">
                                <form-input
                                    v-model="item.pessoa.documento.nis"
                                    label="NIS"
                                    :required="true"
                                    :readonly="
                                        item.pessoa.documento.nao_sabe_nis == 1
                                            ? true
                                            : false
                                    "
                                />
                                <form-toggle
                                    grid="6"
                                    v-model="item.pessoa.documento.nao_sabe_nis"
                                    label="Não sabe"
                                />
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-12">

                            <div class="row">

                                <div class="d-flex align-items-end">

                                    <form-input
                                        v-model="item.pessoa.documento.cpf"
                                        label="CPF"
                                        v-mask="'###.###.###-##'"
                                        placeholder="000.000.000-00"
                                        :required="true"
                                        :readonly="
                                            item.pessoa.documento.nao_sabe_cpf == 1
                                                ? true
                                                : false
                                        "
                                    />

                                    <button
                                        v-if="apiSeproAtiva === true"
                                        type="button"
                                        class="btn ms-2"
                                        style="background: transparent; border: none; padding-left:0px;"
                                        @click="abrirConsultaCpf"
                                    >
                                        🔍
                                    </button>

                                </div>
                                
                            </div>

                            <div class="row">
                                <form-toggle
                                    grid="6"
                                    v-model="item.pessoa.documento.nao_sabe_cpf"
                                    label="Não sabe"
                                />
                            </div>
                        </div>
                        <div class="col-md-12 p-3 mt-0 d-flex align-items-center">
                            <div class="float-left mr-2">
                                <toggle-button
                                    :sync="true"
                                    color="#5685D8"
                                    id="situacao_rua"
                                    name="situacao_rua"
                                    v-model="item.endereco.situacao_rua"
                                />
                            </div>
                            Marque para cadastro de usuário em situação de rua.
                        </div>
                    </div>
                    <!--Bloco Endereço da Família-->
                    <div
                        class="row mt-3 border-top"
                        v-if="!item.endereco.situacao_rua"
                    >
                        <h5 class="col-md-12 font-weight-bold mt-3">
                            Endereço da Família
                        </h5>
                        <div class="col-md-12">
                            <form-endereco :item="item.endereco" />
                        </div>
                    </div>

                    <div class="row mt-3 border-top" v-else>
                        <h5 class="col-md-12 font-weight-bold mt-3">
                            Referência para localização do Usuário/Família em
                            Situação de Rua
                        </h5>
                        <form-input
                            v-model="item.endereco.referencia_endereco"
                            label="Descrição da referência"
                            :required="true"
                        />
                    </div>

                    <div class="row mt-3 border-top">
                        <div class="col-md-12 p-3 mt-2 d-flex align-items-center">
                            <div class="float-left mr-2">
                                <toggle-button
                                    :sync="true"
                                    color="#5685D8"
                                    id="abrigo"
                                    name="abrigo"
                                    v-model="item.endereco.abrigo"
                                />
                            </div>
                            Endereço de Acolhimento Institucional?
                        </div>
                    </div>

                    <!--Bloco Forma de Ingresso na Unidade-->
                    <div class="row mt-3 border-top">
                        <h5 class="col-md-12 font-weight-bold mt-3">
                            Forma de Ingresso na Unidade
                        </h5>

                        <form-select
                            v-model="item.ingresso.forma"
                            grid="12"
                            label="De que forma a família (ou membro da família) acessou a Unidade para o primeiro atendimento?"
                            :itens="$root.arrays.forma_ingresso"
                            :required="true"
                        />

                        <form-input
                            v-model="item.ingresso.nome_unidade_origem"
                            grid="6"
                            label="Nome da unidade/órgão de origem"
                        />

                        <form-input
                            v-model="item.ingresso.nome_contato_unidade_origem"
                            grid="6"
                            label="Contato do órgão/unidade"
                        />

                        <form-textarea
                            v-model="item.ingresso.descricao_ingresso"
                            grid="12"
                            label="Quais as razões, demandas ou necessidades que motivaram o primeiro atendimento?"
                        />
                    </div>
                    <div class="row mt-3">
                        <form-select
                            v-model="
                                item.ingresso.beneficiaria_programa_ingresso
                            "
                            label="Assinale abaixo caso a família seja beneficiária, ou algum de seus membros, de pelo menos um dos seguintes programas sociais:"
                            :itens="$root.arrays.programas"
                            :multiple="true"
                        />
                        <!-- <multiselect
								v-model="item.beneficiaria_programa_ingresso"
								:options="programas"
								placeholder="Selecione uma ou mais opção"
								:multiple="true"
								:taggable="true"
								@tag="addTag"
							></multiselect> -->
                        <!-- </div> -->
                        <form-input
                            v-model="item.ingresso.nome_programa_ingresso"
                            label="Nome do programa prioritário"
                        />
                    </div>

                    <div class="float-right mt-3">
                        <router-link
                            class="btn btn-danger"
                            to="/dashboard/familias"
                        >
                            <i class="mdi mdi-close" />
                            {{ $t("Cancelar") }}
                        </router-link>
                        <button
                            class="btn btn-success btn-submit"
                            data-style="zoom-in"
                            type="submit"
                        >
                            <i class="mdi mdi-content-save" />
                            {{ $t("Salvar") }}
                        </button>
                    </div>
                </form>
            </template>
        </b-card>
    </div>
</template>
<script>
export default {
    name: "Add",
    data() {
        return {
            item: {
                pessoa: {
                    nome_completo: null,
                    nome_social: null,
                    data_nascimento: null,
                    sexo: null,
                    cor_raca: null,
                    documento: {},
                },
                endereco: {
                    numero_endereco: null,
                    complemento_endereco: null,
                    referencia_endereco: null,
                    abrigo: false,
                    localidade_id: null,
                    logradouro_id: null,
                    estado_id: null,
                    cidade_id: null,
                    situacao_rua: false,
                    cidade: null,
                    estado: null,
                    localidade: null,
                    logradouros: null,
                    cep: null,
                },
                ingresso: {
                    forma: null,
                },
            },
            // localidades: [],
            // logradouros: [],
            // localidade_bairro: "",
            // logradouro: "",
            // loading: false,
            // loadingLogradouros: false,
            showfiltroNomeSocial: false,
            apiSeproAtiva: null,
        };
    },
    watch: {
        "item.pessoa.nome_completo": function (val) {
            this.item.pessoa.nome_completo = val
                .normalize("NFD")
                .replace(/([\u0300-\u036f])/g, "")
                .replace(/([^\w]+|\s+)/g, "-")
                .replace(/\-+/g, " ")
                .toUpperCase();
        },
    },
    methods: {

        buscarConfiguracaoApiSepro() {
            this.apiSeproAtiva = null;

            axios.get('/api_serpro_cpf/familia-api-sepro-ativo')
                .then(response => {
                    const ativo = response.data.ativo;

                    if (ativo === null || ativo === undefined || ativo === '') {
                        this.apiSeproAtiva = false;
                        return;
                    }

                    this.apiSeproAtiva = ativo === true || ativo === 1 || ativo === '1';
                })
                .catch(error => {
                    console.error('Erro ao buscar configuração da API SEPRO:', error);

                    this.apiSeproAtiva = false;
                });
        },

        abrirConsultaCpf() {

            let cpf = this.item.pessoa.documento.cpf.replace(/\D/g, '');
            let url = `/api_serpro_cpf/consultar?cpf=${cpf}`;
            
            window.open(
                url,
                'consultaCpf',
                'width=700,height=500,top=100,left=200'
            );

        },

        // addTag(newTag) {
        // 	const tag = {
        // 		name: newTag,
        // 		code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
        // 	};
        // 	this.programas.push(tag);
        // 	this.item.beneficiaria_programa_ingresso.push(tag);
        // },
        addItem() {
            this.item.origem = 2;
            if(this.item.pessoa.documento.nao_sabe_cpf == 1) delete this.item.pessoa.documento.cpf;
            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();
            axios
                .post(`api/dashboard/familias`, { item: this.item })
                .then((response) => {
                    this.$snack.success({
                        button: false,
                        text: response.data.data.message
                            ? response.data.data.message
                            : "Usuário/Familia cadastrada com sucesso.",
                    });
                    ladda.stop();

                    if (this.item.endereco.situacao_rua) {
                        this.$router.push({
                            path: `/dashboard/usuario/edit/${response.data.data.dados.id}`,
                            query: { situacao_rua: true },
                        });
                    } else {
                        this.$router.push(
                            `/dashboard/familias/edit/${response.data.data.familia.id}`
                        );
                    }
                });
        }
        // setLocalidade() {
        // 	setTimeout(() => {
        // 		var item = this.$refs.select.getValueSelected();
        // 		if (item) {
        // 			this.item.endereco.localidade.nome_localidade = item.value;
        // 			this.item.endereco.localidade.id = item.id;
        // 			this.setSelected(item.id);
        // 		}
        // 	}, 1000);
        // },
        // setLogradouro() {
        // 	setTimeout(() => {
        // 		var item = this.$refs.selectLogradouro.getValueSelected();
        // 		if (item) {
        // 			this.item.endereco.logradouro.nome_logradouro = item.value;
        // 			this.item.endereco.logradouro.id = item.id;
        // 		}
        // 	}, 1000);
        // },
        // searchLocalidade(search) {
        // 	if (search != "") {
        // 		this.loading = true;
        // 		this.$refs.select.openOptions(false);
        // 		axios
        // 			.get(`api/dashboard/enderecos/pesquisar_bairro?q=${escape(search)}`)
        // 			.then((response) => {
        // 				this.localidades = response.data;
        // 				this.$refs.select.openOptions(false);
        // 			})
        // 			.finally(() => {
        // 				this.$refs.select.closeOptions(false);
        // 				setTimeout(() => {
        // 					this.loading = false;
        // 					this.$refs.select.openOptions(true);
        // 					this.loadingLogradouros = false;
        // 				}, 3000);
        // 			});
        // 	}
        // },

        // setSelected(value) {
        // 	this.loadingLogradouros = true;
        // 	if (value) {
        // 		axios
        // 			.get(`api/dashboard/enderecos/pesquisar_logradouro?logradouro=${escape(value)}`)
        // 			.then((response) => {
        // 				this.logradouros = response.data;
        // 			})
        // 			.finally(() => {
        // 				this.loadingLogradouros = false;
        // 			});
        // 	}
        // },


    },

    mounted() {

        this.buscarConfiguracaoApiSepro();

        window.preencherDados = (dados) => {

            if (!this.item.pessoa.nome_completo?.trim()){

                this.item.pessoa.nome_completo = dados.nome

            }

            if (!this.item.pessoa.data_nascimento){

                this.item.pessoa.data_nascimento = dados.nascimento_formatado

            }

        };


    }

};
</script>
